import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, NavigationStart, ActivatedRoute, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { LayoutService } from "./layout/layout.service";
import { Title } from '@angular/platform-browser';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { TranslateService } from "@ngx-translate/core";
import { BlockUIModule } from 'ng-block-ui';

import { AppRoutes } from "./app.routes";
import { filter, tap, map, mergeMap } from 'rxjs/operators';
import { environment } from "../environments/environment";
import { isNull } from "./modules/common/utils";
import { GlobalLoadingComponent } from "./modules/common/components/global-loading/global-loading.component";


@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	standalone: true,
	imports: [RouterModule, MatDialogModule, CommonModule, BlockUIModule],
	providers: [LayoutService]
})
export class AppComponent implements OnInit {

	public AppConfig: any;
	public rightPanelOpen = false;

	/** Template de loading moderno usado pelo block-ui (interceptor); quando header blockLoading está presente, o loading não é exibido. */
	public loadingTemplate = GlobalLoadingComponent;

	constructor(private router: Router, public dialog: MatDialog, private titleService: Title, private activatedRoute: ActivatedRoute, private translate: TranslateService, private layoutService: LayoutService) { }

	ngOnInit() {
		this.AppConfig = environment;

		this.layoutService.rightPanelState$.subscribe(
			state => this.rightPanelOpen = state
		);

		// Scroll to top on route change
		this.router.events.subscribe(evt => {
			if (evt instanceof NavigationStart) {
				if (evt.url.startsWith("/app"))
					return;
				var queryParamIndex = evt.url.indexOf("?") - 1;
				if (queryParamIndex == -2) queryParamIndex = evt.url.length;
				var rotaValida = AppRoutes.find(
					route => route.path?.indexOf(evt.url.substr(1, queryParamIndex)) != -1
				);
				if (rotaValida) return;
				this.router.navigate(["/app/template"]);
			}

			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			window.scrollTo(0, 0);
		});

		this.router.events.pipe(
			filter((event) => event instanceof NavigationStart),
			tap(() => this.dialog.closeAll())
		).subscribe();

		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => {
					let route = this.activatedRoute;

					while (route.firstChild)
						route = route.firstChild;

					return route;
				}),
				mergeMap((route) => route.data)
			)
			.subscribe((event) => {

				if (isNull(event['title'])) {
					this.titleService.setTitle('TalkMaestria');
				}
				else {
					let title = this.translate.instant(`${event['title']}`);
					let pageTitle = (isNull(title)) ? 'TalkMaestria' : `TalkMaestria - ${title}`;
					this.titleService.setTitle(pageTitle);
				}
			});

	}
}
